import PropTypes from "prop-types";
import { DndTable } from "@dpdgroupuk/mydpd-ui";
import React from "react";
import * as S from "~/constants/strings";
import styles from "./AiImportModal.module.scss";
import { Col, Row } from "react-bootstrap";
import { ImportsModels } from "~/pages/Imports/models";
import DndTables from "~/pages/Imports/components/AiImportModal/components/DndTables";
import { compose, lifecycle, withState } from "recompose";
import withDndTableActions from "~/pages/Imports/hocs/withDndTableActions";
import isEqual from "lodash/isEqual";
import { connect } from "react-redux";
import cloneDeep from "lodash/cloneDeep";
import set from "lodash/set";
import AiModal from "~/pages/Imports/components/AiModal";
import isEmpty from "lodash/isEmpty";
import { ImportsFields } from "~/constants/forms";
import { AiImportTitle } from "~/components/Icon";
import classNames from "classnames";

const AiImportModal = props => {
  const {
    aiImportToggle,
    aiApplyToggle,
    importedFields,
    onAiBackClick,
    onCancelAiSuggestion,
    onSubmitAiSuggestion,
    onApplyAiSuggestion,
    warning,
  } = props;

  return (
    <>
      <AiModal
        id={"ai-import-file-modal"}
        classes={{ modalContainer: styles.modalContainer }}
        open={aiImportToggle.value}
        onSubmit={onSubmitAiSuggestion}
        onCancel={onCancelAiSuggestion}
        title={<AiImportTitle />}
        confirmButtonText={S.SUBMIT}
      >
        {
          <Row>
            <Col className="col-12 mb-3">{S.AI_IMPORT_FILE_INFO}</Col>
            <Col md={12} lg={6} xl={3} className={styles.importedFields}>
              <DndTable
                columns={ImportsModels.IMPORTED_FIELD_COLUMNS}
                data={importedFields}
                classes={{
                  container: styles.tableContainer,
                }}
                initialState={{
                  storageKey: "importedFields",
                }}
              />
            </Col>
            <DndTables {...props} />
          </Row>
        }
      </AiModal>
      <AiModal
        size={"md"}
        open={aiApplyToggle.value}
        onCancel={onAiBackClick}
        onSubmit={onApplyAiSuggestion}
        title={<AiImportTitle />}
        confirmButtonText={S.APPLY}
        closeButtonText={S.BACK}
      >
        <Row>
          <Col className={classNames("col-12", styles.message)}>
            {S.SAVE_AI_SUGGESTION}
          </Col>
          {warning && (
            <Col className={classNames("col-12 mt-3", styles.message)}>
              <b>{S.WARNING}:</b> {warning}
            </Col>
          )}
        </Row>
      </AiModal>
    </>
  );
};

AiImportModal.propTypes = {
  open: PropTypes.bool,
  importedFields: PropTypes.array,
  templateTranslations: PropTypes.array,
  aiInitialData: PropTypes.object,
  warning: PropTypes.string,
  onAiBackClick: PropTypes.func,
  onCancelAiSuggestion: PropTypes.func,
  onSubmitAiSuggestion: PropTypes.func,
  onApplyAiSuggestion: PropTypes.func,
  updateImportForm: PropTypes.func,
  setAiInitialData: PropTypes.func,
  onTranslationChange: PropTypes.func,
};

export default compose(
  withState("importedFields", "setImportedFields", []),
  withState("excludeFields", "setExcludeFields", []),
  withState("includeFields", "setIncludeFields", []),
  withState("warning", "setWarning"),
  connect(
    null,
    (
      dispatch,
      {
        aiImportToggle,
        aiApplyToggle,
        warning,
        setImportedFields,
        setExcludeFields,
        setIncludeFields,
        setAiInitialData,
        setWarning,
        importedFields,
        includeFields,
        excludeFields,
        updateImportForm,
        aiInitialData,
      }
    ) => ({
      updateExcludeIncludeFields: ({ excludeFields, includeFields }) => {
        setExcludeFields(excludeFields);
        setIncludeFields(includeFields);
      },
      updateIncludeFields: includeFields => setIncludeFields(includeFields),
      onTranslationChange: (value, index) => {
        const newIncludeFields = cloneDeep(includeFields);
        set(newIncludeFields, [index, "templateFieldTranslationCode"], value);
        setIncludeFields(newIncludeFields);
      },
      onAiBackClick: () => {
        aiApplyToggle.switchOff();
        aiImportToggle.switchOn();
        warning && setWarning();
      },
      onCancelAiSuggestion: () => {
        aiImportToggle.switchOff();
        setAiInitialData({});
      },
      onSubmitAiSuggestion: () => {
        const warning = ImportsModels.getAiCountError(
          importedFields,
          includeFields
        );
        warning && setWarning(warning);
        aiImportToggle.switchOff();
        aiApplyToggle.switchOn();
      },
      onApplyAiSuggestion: () => {
        updateImportForm({
          excludeFields,
          includeFields,
          [ImportsFields.EXTENSION]: aiInitialData.fileExtension,
          [ImportsFields.DELIMITER]: aiInitialData.delimiter,
          [ImportsFields.HEADER_LINES]: 1,
        });
        setImportedFields([]);
        setExcludeFields([]);
        setIncludeFields([]);
        setAiInitialData({});
        warning && setWarning();
        aiApplyToggle.switchOff();
      },
    })
  ),
  withDndTableActions,
  lifecycle({
    componentDidUpdate(prevProps) {
      const {
        aiInitialData,
        setImportedFields,
        setExcludeFields,
        setIncludeFields,
      } = this.props;

      if (
        !isEmpty(aiInitialData) &&
        !isEqual(aiInitialData, prevProps.aiInitialData)
      ) {
        const { importedFields, excludeFields, includeFields } = aiInitialData;
        setImportedFields(importedFields);
        setExcludeFields(excludeFields);
        setIncludeFields(includeFields);
      }
    },
  })
)(AiImportModal);
